// Raccourcis clavier personnalisables (combinaison complète : Ctrl/⌘, Alt/⌥,
// Maj + touche). Persistés dans les Paramètres (settings.raccourcis) et mis en
// cache localStorage pour les écouteurs globaux (palette, création de RDV,
// tournées). Un raccourci = { mod, alt, shift, key }.

export const SHORTCUT_GROUPS = [
  {
    group: "Global",
    items: [
      { id: "command_palette", label: "Recherche globale (palette de commandes)" },
      { id: "creer_rdv", label: "Créer un rendez-vous" },
    ],
  },
  {
    group: "Tournées — participant sélectionné",
    items: [
      { id: "tournee_valider", label: "Valider le créneau demandé" },
      { id: "tournee_appeler", label: "Appeler le patient" },
      { id: "tournee_sms", label: "Envoyer un SMS" },
    ],
  },
];

export const SHORTCUT_DEFS = SHORTCUT_GROUPS.flatMap((g) => g.items.map((i) => ({ ...i, group: g.group })));

export const DEFAULTS = {
  command_palette: { mod: true, alt: false, shift: false, key: "k" },
  creer_rdv: { mod: false, alt: false, shift: false, key: "n" },
  tournee_valider: { mod: true, alt: false, shift: false, key: "v" },
  tournee_appeler: { mod: true, alt: false, shift: false, key: "a" },
  tournee_sms: { mod: true, alt: false, shift: false, key: "s" },
};

// Combinaisons souvent réservées par le navigateur/OS (blocage non garanti).
const RESERVED_KEYS = ["n", "t", "w", "q", "l", "d"];
export function isReserved(sc) {
  return !!sc && sc.mod && !sc.alt && !sc.shift && RESERVED_KEYS.includes((sc.key || "").toLowerCase());
}

// Raccourcis fixes (navigation) — affichés en lecture seule.
export const FIXED_SHORTCUTS = [
  { keys: "Échap", label: "Fermer le volet / la fenêtre ouverte" },
  { keys: "↑ / ↓", label: "Naviguer dans les listes et aperçus" },
  { keys: "Entrée", label: "Ouvrir / valider l'élément sélectionné" },
  { keys: "← / →", label: "Aperçu agenda : RDV précédent / suivant" },
];

const LS_KEY = "sx_shortcuts";

function coerce(id, v) {
  if (!v) return { ...DEFAULTS[id] };
  if (typeof v === "string") return { mod: !!DEFAULTS[id]?.mod, alt: false, shift: false, key: v.toLowerCase() };
  return { mod: !!v.mod, alt: !!v.alt, shift: !!v.shift, key: (v.key || "").toLowerCase() };
}

export function loadShortcuts() {
  let raw = {};
  try { raw = JSON.parse(localStorage.getItem(LS_KEY) || "{}"); } catch { raw = {}; }
  const out = {};
  for (const id of Object.keys(DEFAULTS)) out[id] = coerce(id, raw[id]);
  return out;
}

export function saveShortcutsLocal(map) {
  const clean = {};
  for (const id of Object.keys(DEFAULTS)) clean[id] = coerce(id, map?.[id]);
  try { localStorage.setItem(LS_KEY, JSON.stringify(clean)); } catch { /* ignore */ }
}

export function getShortcut(id) { return loadShortcuts()[id]; }

export function matchShortcut(e, id) {
  const sc = getShortcut(id);
  if (!sc || !sc.key) return false;
  const mod = e.metaKey || e.ctrlKey;
  if (!!sc.mod !== !!mod) return false;
  if (!!sc.alt !== !!e.altKey) return false;
  if (!!sc.shift !== !!e.shiftKey) return false;
  return (e.key || "").toLowerCase() === sc.key.toLowerCase();
}

export function comboLabel(sc) {
  if (!sc || !sc.key) return "—";
  const parts = [];
  if (sc.mod) parts.push("Ctrl/⌘");
  if (sc.alt) parts.push("Alt/⌥");
  if (sc.shift) parts.push("Maj");
  parts.push((sc.key || "").toUpperCase());
  return parts.join(" + ");
}

export function sameCombo(a, b) {
  if (!a?.key || !b?.key) return false;
  return !!a.mod === !!b.mod && !!a.alt === !!b.alt && !!a.shift === !!b.shift &&
    (a.key || "").toLowerCase() === (b.key || "").toLowerCase();
}
